export default "__VITE_ASSET__2ed942ab__"